import * as angular from 'angular';
import Backoff from 'backo';
import { Observable, Subscription } from 'rxjs';

export class PollingObservable<T> extends Observable<{ count: number; value: T }> {
  constructor(backoffOptions: { min?: number; max?: number; jitter?: number; factor?: number }, stream: Observable<T>) {
    super((observer) => {
      const backoff = new Backoff(backoffOptions);

      let count = 0;
      let timeoutId = setTimeout(tick, backoff.duration());
      function tick() {
        stream.subscribe(
          (res) => {
            observer.next({ count, value: res as T });
            if ((timeoutId as any) > 0) {
              timeoutId = setTimeout(tick, backoff.duration());
            }
          },
          (err) => {
            observer.error(err);
            observer.complete();
          }
        );
        count += 1;
      }
      return new Subscription(() => {
        clearTimeout(timeoutId);
        timeoutId = -1 as any;
      });
    });
  }
}

export function observifyAngularPromise<T>(func: () => angular.IPromise<T>): Observable<T> {
  return Observable.create((observer) => {
    func()
      .then((res) => observer.next(res))
      .catch((err) => observer.error(err))
      .finally(() => observer.complete());
  });
}
